import { Fragment, useEffect, useRef, useState } from "react";
import { useRefinementList, useClearRefinements } from "react-instantsearch";
import { isValidArray, capitalizeFirstLetter } from "../../Layout/Common/common";
import { Offcanvas } from "bootstrap";

export const FacetFilterMobileLite = ({ attribute, limit = 30, showMore = true, defaultValue, setSelectedFilter }) => {
  const { items, refine } = useRefinementList({
    attribute: attribute,
    sortBy: ["count:desc", "name:asc"],
  });
  const { canRefine, refine: clearAll } = useClearRefinements({
    includedAttributes: [attribute], // clears only this facet
  });

  const [showAll, setShowAll] = useState(false);
  const [container, setContainer] = useState("");
  const [pending, setPending] = useState([]);
  const offcanvasRef = useRef(null);
  const modalInstance = useRef(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [sortedItems, setSortedItems] = useState([]);
  const [filterAttribute, setFilterAttribute] = useState("");

  useEffect(() => {
    if (offcanvasRef.current) {
      modalInstance.current = new Offcanvas(offcanvasRef.current, {
        backdrop: true,
      });
    }
  }, [offcanvasRef.current]);

  const handleShow = () => {
    if (modalInstance.current) {
      modalInstance.current.show();
    } else {
      modalInstance.current = new Offcanvas(offcanvasRef.current, {
        backdrop: true,
      });
      modalInstance.current.show();
    }
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };

  const handleChange = (item) => {
    if (pending.includes(item.label)) {
      setPending(pending.filter((v) => v != item.label));
    } else {
      setPending([...pending, item.label]);
    }
    refine(item.value);
  };

  const clearFilter = () => {
    setPending([]);
    clearAll(); // clears only this attribute refinements
  };

  useEffect(() => {
    setSortedItems(items);
    const _displayedItems = showAll ? items : items.slice(0, limit);
    setDisplayedItems(_displayedItems);
    const _activeCount = items.filter((item) => item.isRefined).length;
    setActiveCount(_activeCount);

    if (defaultValue) {
      refine(defaultValue);
    }
    setContainer(`${String(attribute).split(".").at(-1)}-filtersMob`);
    setFilterAttribute(String(attribute).split(".").at(-1));
  }, [items, refine, showAll, limit, attribute, defaultValue]);

  useEffect(() => {
    if (setSelectedFilter) {
      if (activeCount > 0) {
        setSelectedFilter((prev) => (prev.includes(attribute) ? prev : [...prev, attribute]));
      } else {
        setSelectedFilter((prev) => prev.filter((item) => item != attribute));
      }
    }
  }, [setSelectedFilter, activeCount, attribute]);

  if (isValidArray(displayedItems)) {
    return (
      <Fragment>
        <li key={filterAttribute} data-value={filterAttribute} style={{ cursor: "pointer" }} onClick={handleShow}>
          {capitalizeFirstLetter(filterAttribute)}
          <i className="fa-solid fa-chevron-right" />
        </li>
        <div
          className="offcanvas offcanvas-end filterMobSelection"
          tabIndex={-1}
          id={container}
          key={container}
          aria-labelledby="offcanvasRightLabelTwo"
          style={{ zIndex: 1061 }}
          ref={offcanvasRef}
        >
          <div className="offcanvas-header">
            <i className="fa-solid fa-arrow-left" data-bs-dismiss="offcanvas" aria-label="Close" onClick={handleHide} />
            <h5 id="offcanvasRightLabel">
              {capitalizeFirstLetter(filterAttribute)}({activeCount})
            </h5>
            {canRefine && (
              <p className="fs-13 text-decoration-underline" style={{ cursor: "pointer" }} onClick={clearFilter}>
                Clear All
              </p>
            )}
          </div>
          <div className="offcanvas-body">
            {/* Filter List */}
            <div className="filter-selection-wrapper">
              <div className="filterSelection-list">
                <div className="filterSelection-listInner">
                  {displayedItems &&
                    displayedItems.map((item) => (
                      <div className="form-check custom-check" key={item.label}>
                        <div className="signature-req-input">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={item.label}
                            checked={pending.includes(item.label)}
                            onChange={() => handleChange(item)}
                          />
                        </div>
                        <label className="form-check-label form-check-color" htmlFor={item.label}>
                          {["color", "colour"].includes(filterAttribute.toLowerCase()) && (
                            <ColorValue color={item.label} />
                          )}
                          {item.label}
                          <span className="product-count">({item.count})</span>
                        </label>
                      </div>
                    ))}
                </div>
                <div className="filterSelection-collapse">
                  {showMore && sortedItems.length > limit && (
                    <a
                      className="text-decoration-underline collapseMore"
                      data-bs-toggle="collapse"
                      href="#collapseManufacture"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBrand"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? "Show Less" : "Show More"}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="offcanvas-footer offcanvas-filterFooter">
            <a href="#." role="button" onClick={clearFilter} className="btn btn-unavailable fs-13 fw-medium mb-0">
              Clear Filter
            </a>
            <div className="button-effect">
              <a data-bs-dismiss="offcanvas" aria-label="Close" className="btn btn-addcart fs-13 fw-medium mb-0">
                Apply Filter
              </a>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
};

const ColorValue = ({ color }) => {
  const [hexValue] = useState(color);
  return <span className="product-color" style={{ backgroundColor: hexValue }}></span>;
};
